export const encode = (data: string) => {
  const encoder = new TextEncoder();
  return encoder.encode(data);
};
